<app-header></app-header>
<div class="content" role="main">
  <div class="content-margin">
    <div class="col-xl-12 col-lg-11 col-md-11 col-sm-11 mx-auto">
      <h1 role="heading" class="mt-5" attr.aria-label="{{ 'claim.title' | translate }}">{{ "claim.title" | translate }}
      </h1>

      <p class="info my-5" attr.aria-label="{{ 'claim.fieldsMandatory' | translate }}">
        {{ "claim.fieldsMandatory" | translate }}</p>

      <p class="mt-4" attr.aria-label="{{ 'landingModal.continueClaim' | translate }}">
        {{ "landingModal.continueClaim" | translate }}</p>
      <button role="button" class="btn btn-wsib"
        attr.aria-label="{{ 'landingModal.start' | translate }}">{{ "landingModal.start" | translate }}</button>
      <button role="button" class="btn btn-wsib"
        attr.aria-label="{{ 'landingModal.continue' | translate }}">{{ "landingModal.continue" | translate }}</button>
    </div>
  </div>
</div>